import { render, staticRenderFns } from "./SettingsLabelsEdit.vue?vue&type=template&id=0fe4f1fc&scoped=true&"
import script from "./SettingsLabelsEdit.vue?vue&type=script&lang=js&"
export * from "./SettingsLabelsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe4f1fc",
  null
  
)

export default component.exports